//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { SchoolInvoiceNumberSettingsUpdateItem } from './SchoolInvoiceNumberSettingsUpdateItem';

export class SchoolInvoiceSettingsUpdateItem extends ItemBase {
    AccentHexadecimalColor?: string | null;
    Address?: string | null;
    AutoInvoiceSendHour?: number;
    Footer?: string | null;
    GroupChargesByStudent?: boolean;
    InvoiceNumberSettings?: SchoolInvoiceNumberSettingsUpdateItem | null;
    LineItemTaxInclusive?: boolean;
    OverdueReminderDays?: number | null;
    SendSMSNotifications?: boolean;
    ShowEventLocationOnInvoice?: boolean;
    ShowNegativeInvoicesAsBalanceRemaining?: boolean;
    Title?: string | null;

    constructor(initializer?: Partial<SchoolInvoiceSettingsUpdateItem>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "SchoolInvoiceSettingsUpdateItem";
}
